import { render, staticRenderFns } from "./ServidorPublicoRJ.vue?vue&type=template&id=00724601"
import script from "./ServidorPublicoRJ.vue?vue&type=script&lang=js"
export * from "./ServidorPublicoRJ.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublicoRJ.vue?vue&type=style&index=0&id=00724601&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports